/** Ruta protegida: renderiza el elemento solo si hay sesión (loggedUser con datos); si no, redirige al login con Navigate. */
import React from "react";
import { Navigate } from "react-router-dom";
import { LoggedUserInnerwork } from "@/types";

interface PrivateRouteProps {
  element: React.ReactNode;
  loggedUser: LoggedUserInnerwork;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element, loggedUser }) => {
  return Object.keys(loggedUser).length > 0 ? <>{element}</> : <Navigate to="/" replace />;
};

export default PrivateRoute;
